import { render, staticRenderFns } from "./JoinBanner.vue?vue&type=template&id=2a0d378f&scoped=true&"
import script from "./JoinBanner.vue?vue&type=script&lang=js&"
export * from "./JoinBanner.vue?vue&type=script&lang=js&"
import style0 from "styles/views/join/joinbanner.css?vue&type=style&index=0&id=2a0d378f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d378f",
  null
  
)

export default component.exports